import * as consts from './GalleryConsts';

const initialState = {
    activeSlideName: '',
    imageSizeParams: {
        thumbnail: '?w=118&h=86',
        original: '?w=404&h=295',
        walk: '?w=640&h=480',
        wide: '?w=1024&h=680',
        fullhd: '?w=1920&h=1276'
    },
    imagesPath: '',
    galleryExists: false,
    allPhotos: false,
    galleryBtnVisible: false,
    images: []
};


const gallery = (state = initialState, action) => {
    switch (action.type) {
        case consts.SET_ACTIVE_IMAGE:
            return {
                ...state,
                activeSlideName: action.payload
            }
        case consts.SHOW_ALL_PHOTOS:
            return {
                ...state,
                allPhotos: true
            }
        case consts.GET_GALLERY_FULFILLED:
            if (!action.payload.gallery) {
                return initialState
            }

            return {
                ...state,
                imagesPath: action.payload.gallery.base_path,
                images: action.payload.gallery.images,
                galleryBtnVisible: !!+action.payload.gallery.images.length,
                activeSlideName: action.payload.activeSlideName
            }

        default:
            return state
    }
}

export default gallery;
